import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { Action, ActionReducer, StoreModule } from '@ngrx/store';
import { checkinPassengerInputReducer } from './checkin-passenger-input.reducer';
import { CHECKIN_PASSENGER_INPUT_STORE_NAME, CheckinPassengerInputState } from './checkin-passenger-input.state';

/** Token of the CheckinPassengerInput reducer */
export const CHECKIN_PASSENGER_INPUT_REDUCER_TOKEN = new InjectionToken<
  ActionReducer<CheckinPassengerInputState, Action>
>('Feature CheckinPassengerInput Reducer');

/** Provide default reducer for CheckinPassengerInput store */
export function getDefaultCheckinPassengerInputReducer() {
  return checkinPassengerInputReducer;
}

@NgModule({
  imports: [StoreModule.forFeature(CHECKIN_PASSENGER_INPUT_STORE_NAME, CHECKIN_PASSENGER_INPUT_REDUCER_TOKEN)],
  providers: [{ provide: CHECKIN_PASSENGER_INPUT_REDUCER_TOKEN, useFactory: getDefaultCheckinPassengerInputReducer }],
})
export class CheckinPassengerInputStoreModule {
  public static forRoot<T extends CheckinPassengerInputState>(
    reducerFactory: () => ActionReducer<T, Action>
  ): ModuleWithProviders<CheckinPassengerInputStoreModule> {
    return {
      ngModule: CheckinPassengerInputStoreModule,
      providers: [{ provide: CHECKIN_PASSENGER_INPUT_REDUCER_TOKEN, useFactory: reducerFactory }],
    };
  }
}
